// Форма для обработки файла
import response from "./response";
import urls from "../../urls";
import errorMessage from "../../domain/error-message";
import dropzone from "../../components/dropzone/dropzone";
import dropzoneUpload from "../../components/dropzone/data/upload";
import dropzoneStates from "../../components/dropzone/data/states";
import errors from "../../mixins/errors";
import state from "../../mixins/state";

const template = `
    <div class="workspace-uploader">
        <dropzone
            @dropzone:upload="upload"
            @update:state="setState"
            :error="error"
            :state="state"
            :header="header"
            :note="note"
            :mobile-header="mobileHeader"
            :mobile-note="mobileNote"
        >
        </dropzone>
    </div>`;

const props = {
    header: String,
    note: String,
    mobileHeader: String,
    mobileNote: String,
    url: {
        type: String,
        default: urls.process.upload.getUrl(),
    },
};

const methods = {
    async upload(files, uploadHandler) {
        try {
            if (!this.validate(files)) {
                document.querySelector("#id_document").value = "";
                return;
            }
            this.setState(dropzoneStates.STATES.UPLOADING);
            this.result = await dropzoneUpload.uploader(this.url, files[0], uploadHandler);
            this.onRequestComplete();
        } catch (e) {
            console.log(e);
            this.setErrors(errorMessage.FILE_UNEXPECTED_ERROR);
        }
    },

    validate(files) {
        if (typeof this.$root.$data.validator !== "function") {
            return true;
        }
        this.setErrors(this.$root.$data.validator(files[0]));
        return !this.hasErrors();
    },

    onRequestComplete() {
        if (response.canRedirect(this.result)) {
            window.location.href = this.result.redirect_to;
            return;
        }
        this.setErrors(response.getErrors(this.result));
        if (this.hasErrors()) {
            this.setState(dropzoneStates.STATES.INITIAL);
        }
    },
};

const mounted = function () {
    this.state = dropzoneStates.STATES.INITIAL;
};

export default {
    template,
    methods,
    mixins: [errors, state],
    props,
    mounted,
    components: { dropzone },
};
